import React, {useEffect} from "react"
import UserPages from "./user-pages/UserPages";
import cogoToast from "cogo-toast"
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import * as handlers from "../../../_redux/selected-user/selectedUserHandlers";
import ViewUserSkeleton from "./ViewUserSkeleton"

const ViewUser = props => {

    const selectedUser = useSelector(({selectedUser}) => {
        const data = selectedUser?.data?.profile?.basic?.userId === props.match.params.userId ? selectedUser.data : null;
        return  {...selectedUser, data};
    }, shallowEqual);

    // Redux dispatch
    const dispatch = useDispatch();

    /* Fetch User profile */
    useEffect(() => {
        dispatch(handlers.fetchUserProfile(props.match.params.userId));
    }, [dispatch, props.match.params.userId]);

      
    /* Notification Pop up */
    useEffect(() => {
        if (selectedUser?.notification){
            cogoToast[selectedUser.notification.type](selectedUser.notification.message);
            dispatch(handlers.clearNotification());
        }
    });

    return selectedUser?.data ?
            <UserPages {...props} />
            :
            <ViewUserSkeleton />
}

export default ViewUser;

